import { CART_ORDER_LC } from '@/const/localStorage'
import store from '@/store/index'
import Utils from './Utils'

const cardUtils = {
    parseStringToArray(val: any) {
        if (!val) return []
        try {
            const parsed = JSON.parse(val)
            return Array.isArray(parsed) ? parsed : []
        } catch {
            try {
                const parsed = JSON.parse(String(val).replace(/'/g, '"'))
                return Array.isArray(parsed) ? parsed : []
            } catch {
                return []
            }
        }
    },

    setLcCart(val: any) {
        const raw = localStorage.getItem(CART_ORDER_LC)
        let cart: any[] = []

        try {
            cart = raw ? JSON.parse(raw) : []
            if (!Array.isArray(cart)) cart = []
        } catch (e) {
            cart = []
        }

        const quantity = Number(val?.quantity) > 0 ? Number(val.quantity) : 1
        const unitPrice = Number(val?.priceUse ?? val?.minPrice ?? 0) || 0
        const productId = val?.productId

        const nextItem = {
            ...val,
            productId,
            quantity,
            minPrice: unitPrice,
            priceUse: unitPrice * quantity,
        }

        const index = cart.findIndex((item) => item?.productId == productId)

        if (index !== -1) {
            cart[index] = {
                ...cart[index],
                ...nextItem,
            }
        } else {
            cart.push(nextItem)
        }

        localStorage.setItem(CART_ORDER_LC, JSON.stringify(cart))
        this.setLoadCart()
    },

    setLoadCart() {
        store.dispatch('setLoadCart', Utils.randomText(5))
    },

    getLcCart() {
        const dataOrder = localStorage.getItem(CART_ORDER_LC)
        if (dataOrder != null && dataOrder != undefined) {
            return this.parseStringToArray(dataOrder).reverse()
        }
        return []
    },

    setLcOrderChange(val: any) {
        let dataCart: any[] = []
        const dataOrder = localStorage.getItem(CART_ORDER_LC)
        if (dataOrder != null && dataOrder != undefined && dataOrder.length > 10) {
            const dataOld = this.parseStringToArray(dataOrder)
            dataCart = dataOld
            for (let i = 0; i < dataOld.length; i++) {
                const item = dataOld[i].id
                const valId = val.id
                if (item == valId) {
                    dataCart[i].quantity = val.quantity
                    dataCart[i].priceUse =
                        (dataCart[i].price - dataCart[i].priceDiff) * val.quantity
                }
            }
        }

        localStorage.setItem(CART_ORDER_LC, JSON.stringify(dataCart))
        this.setLoadCart()
    },

    removeLcCart(val: any) {
        let dataCart: any[] = []
        const dataOrder = localStorage.getItem(CART_ORDER_LC)
        if (dataOrder != null && dataOrder != undefined) {
            const dataOld = this.parseStringToArray(dataOrder)
            dataCart = dataOld.filter((item) => item?.productId != val)
        }
        localStorage.setItem(CART_ORDER_LC, JSON.stringify(dataCart))
        this.setLoadCart()
    },
}

export default cardUtils
